const AUTH_USER = 'AUTH';
const UNAUTH_USER = 'UNAUTH';

export {
  AUTH_USER,
  UNAUTH_USER,
};



// WEBPACK FOOTER //
// ./src/redux/actions/types/authTypes.js